var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/congrat_session.b1471955.png","uri@2x": __webpack_public_path__ + "static/media/congrat_session.e34b5f51.png","uri@3x": __webpack_public_path__ + "static/media/congrat_session.fbcae2b5.png",
    width: 221,
    height: 221
});